import { useListContext } from './ListContext';
import { EventCallback, useEventsSubscriber } from 'event-bus';
import { useCallback } from "react";
import { debounce } from "lodash";

export interface ListDataUpdaterProps {
  eventName: string | string[];
  prefix?: string;
  debounceMs?: number;
}

export function ListDataRefresher(props: ListDataUpdaterProps) {
  const listContext = useListContext();

  const callback = useCallback(
    debounce(() => {
      listContext.refreshData?.();
    }, props.debounceMs ?? 0),
    []
  );

  const eventNames = Array.isArray(props.eventName) ? props.eventName : [props.eventName];

  const subscribesMap = eventNames.reduce<Record<string, EventCallback>>((acc, eventName) => {
    acc[eventName] = callback;
    return acc;
  }, {});

  useEventsSubscriber(
    `${props.prefix || ''}-ListDataRefresher`,
    subscribesMap,
  );

  return null;
}
